export const ProductTilePriceStyles = {
    omnibusWrapper: {
        display: "inline-flex",
        flexWrap: "wrap", // allow wrapping
        alignItems: "center",
        gap: "0.25rem",
        fontSize: "desktopBodyTextTiny",
        fontWeight: "bold",
        lineHeight: "short",
        color: "gray.500",
    },
    omnibusDiscount: {
        color: "red.100",
        fontSize: "inherit",
        fontWeight: "bold",
    },
};
